import { EntityDescriptor, Utils, ENT_READ, PrivateRouteProps, PrivateRoute } from "@crispico/foundation-react";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";
import React from "react";
import { Route } from "react-router-dom";
import { MissionsAwaitingForDriversPageHOC } from "./MissionsAwaitingForDriversPage";
import { missionEntityDescriptor } from "AppEntityDescriptors";

export class Mission2EntityDescriptor extends EntityDescriptor {

    protected customize() {
        this.isInDefaultColumnConfig(true, "creationDate", "humanResource", "equipmentResource", "startTime", "endTime", "type", "comment", "currentState", "mobileDevice")
            .removeFieldDescriptors("humanResourceId", "equipmentResourceId", "inactivityTypeId", "mobileDeviceId", "dataString", "dataVersion", "day", "currentStopId")
            .addFieldDescriptor({ name: "creationDate", type: FieldType.date, format: Utils.dateTimeWithSecFormat, propsForEditor: { hasTime: true } })
            .addFieldDescriptor({ name: "startTime", type: FieldType.date, format: Utils.dateTimeWithSecFormat, propsForEditor: { hasTime: true } })
            .addFieldDescriptor({ name: "endTime", type: FieldType.date, format: Utils.dateTimeWithSecFormat, propsForEditor: { hasTime: true } })
    }
}

export const MissionsAwaitingForDriversPageUrl = "/MissionsAwaitingForDrivers";
export const missionsAwaitingForDriversPageRoute = (computeRoute: (props: PrivateRouteProps) => JSX.Element) =>
    <PrivateRoute key="missionsAwaitingForDriversPage"
        path={MissionsAwaitingForDriversPageUrl}
        render={(props) => <MissionsAwaitingForDriversPageHOC {...props} id="missionsAwaitingForDriversPage" />}
        computeRoute={computeRoute} />

export const missionsAwaitingForDriversPageMenuEntry = () => {
    return {
        id: "missionsAwaitingForDriversPage",
        content: _msg("MissionsAwaitingForDriversPage.title"),
        to: MissionsAwaitingForDriversPageUrl, exact: true, icon: "list",
        permission: Utils.pipeJoin([ENT_READ, missionEntityDescriptor.name])
    }
};

